import React from 'react'
import styled from '@theme/styled-components'

interface Props {
  children: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
}

const Card = ({ children }: Props) => {
  return (
    <Container>
      <>{children}</>
    </Container>
  )
}

export default Card

const Container = styled('div')`
  background-color: ${(props) => props.theme.colors.cardBackground};
  box-shadow: 0px 0px 15px ${(props) => props.theme.colors.cardShadow};

  border-radius: 15px;
  padding: 25px;
  margin: 25px;
`
